module.exports = __webpack_public_path__ + "img/profile_photo.3dcadabf.jpeg";